export default "__VITE_ASSET__C84$qZpS__"